import css from 'styled-jsx/css'

import { colors, sizes } from '../../../theme'
import common from '../../../theme/common'


export default css`
.container {
  display: flex;
  font-family: 'Open Sans Regular', sans-serif;
  position: relative;
}

.container :global(.icon-techno) {
  width: 10rem;
}

.container :global(.icon-techno img) {
  width: 100%;
}

.container .qrCode {
  margin-top: 1rem;
  max-width: 120px;
  width: 100%;
}

.container .discover {
  ${common.h5}
  color: ${colors.pureWhite};
  margin-bottom: 10px;
  margin-top: 4rem;
}

.container .discover-link .arrow-icon {
  max-width: 22px;
  margin-right: 15px;
}

.container .discover-link {
  display: flex;
  align-items: center;
  ${common.small}
  text-transform: uppercase;
  color: ${colors.pureWhite};
  opacity: .3;
  font-weight: bold;
  margin-bottom: 10px;
}

.container :global(a) {
  text-decoration: none;
}

.container :global(.technologies) {
  display: flex;
  margin-bottom: 4rem;
  flex-wrap: wrap;
  max-width: 50%;
}

.container :global(p.title) {
  ${common.h3}
  color: ${colors.pureWhite};
  margin-bottom: 2rem;
}

.left {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
}

.left :global(.parallax-title) {
  top: -7rem;
  z-index: 0;
}

.right {
  display: flex;
  flex-direction: column;
  flex: 0;
  align-items: flex-start;
  justify-content: center;
  min-width: max-content;
}

.tag-content {
  ${common.h6}
  text-transform: uppercase;
  color: ${colors.yellow};
  margin-bottom: 0.5rem;
}

.container :global(.subtitle) {
  ${common.h4}
  color: ${colors.pureWhite};
  margin: 0;
  margin-bottom: 1rem;
}

.container :global(.description) {
  ${common.regular16};
  max-width: 700px;
  color: ${colors.pureWhite};
  margin-bottom: 3rem;
}

.container :global(.content) {
  ${common.h7}
  text-transform: uppercase;
  color: ${colors.pureWhite};
  margin-right: 2rem;
  margin-bottom: 1rem;
}

.container .tags {
  display: none;
}

@media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
  .container .qrCode {
    display: none;
  }

  .container :global(p.title) {
    ${common.h4}
    margin-bottom: 2rem;
  }


  .container {
    flex-direction: column;
  }

  .container :global(.icon-techno) {
    width: 5rem;
  }

  .left {
    flex: auto;
  }

  .container .tags {
    display: block;
    margin-bottom: 3rem;
  }

  .container :global(.technologies) {
    margin-bottom: 3rem;
  }

  .container .discover {
    margin-top: 3rem;
  }
  
  .right {
    /* flex: auto;
    margin-top: 3rem; */
    display: none;
  }

  .tag-content {
    ${common.h7}
    margin-bottom: 0.5rem;
  }
}
`
